export default {"src":"/wp-content/themes/GKH-Theme/bamistarim/_next/static/media/play-small.e9d47c1f.svg","height":27,"width":17};